export default __webpack_public_path__ + "static/media/skills.79b5b84a.svg";